import { MapPin } from 'lucide-react'

interface BrandProps {
  size?: 'sm' | 'md'
}

export function Brand({ size = 'md' }: BrandProps) {
  const isSm = size === 'sm'
  return (
    <span className="inline-flex items-center gap-2.5 font-semibold tracking-tight">
      <span
        className={[
          'inline-flex items-center justify-center rounded-[10px]',
          'bg-[var(--color-accent)] text-[var(--color-surface)]',
          isSm ? 'w-6 h-6' : 'w-7 h-7',
        ].join(' ')}
        aria-hidden
      >
        <MapPin size={isSm ? 14 : 16} strokeWidth={2.4} />
      </span>
      <span className={isSm ? 'text-[15px]' : 'text-[17px]'}>GeoBorder</span>
    </span>
  )
}
